<template>
  <div class="flex flex-col h-full">
    <div class="flex-auto overflow-scroll">
      <h3 class="text-2xl font-bold pt-4 px-4 flex items-center">
        <button type="button" class="pr-2" @click="router.push('/admin/pricings')">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
          </svg>
        </button>
        {{ pricing.nombre || "Esquema de precios" }}
      </h3>

      <div v-if="loaded && pricing.id" class="p-4">
        <div class="border rounded bg-white p-4">
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 text-sm">
            <div v-for="field in moneyFields" :key="field.key">
              <p class="text-gray-500">{{ field.label }}</p>
              <p class="font-medium mt-1">{{ formatMoney(pricing[field.key]) }}</p>
            </div>
          </div>
        </div>

        <div class="flex items-center justify-between mt-6 mb-3">
          <h4 class="text-lg font-bold">Proveedores activos</h4>
          <span class="text-sm text-gray-500">
            {{ pricing.active_provider_count }}
          </span>
        </div>

        <div v-if="pricing.providers.length" class="border border-b-0 rounded bg-white overflow-hidden">
          <table class="w-full text-sm text-left">
            <thead class="border-b border-b-gray-200">
              <tr>
                <th class="py-3 px-6">Proveedor</th>
                <th class="py-3 px-6">Tipo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="provider in pricing.providers" :key="provider.id" class="border-b">
                <td class="py-3 px-6 font-medium underline">
                  <router-link :to="`/admin/proveedor/${provider.id}`">
                    {{ provider.nombre }}
                  </router-link>
                </td>
                <td class="py-3 px-6">
                  {{ provider.standalone ? "Standalone" : "Administrado" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p v-else class="border rounded bg-white p-4 text-gray-500">
          No hay proveedores activos con este esquema.
        </p>
      </div>

      <div v-if="loaded && !pricing.id" class="p-4 text-gray-500">
        No se encontró el esquema de precios.
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useLoading } from "vue-loading-overlay";
import { useToast } from "vue-toast-notification";
import axios from "axios";

export default {
  name: "Admin Pricing Detail",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const loaded = ref(false);
    const pricing = ref({ providers: [], active_provider_count: 0 });
    const loading = useLoading({ color: "#428b74", loader: "spinner" });
    const moneyFields = [
      { key: "almacen", label: "Tarifa mensual por tarima" },
      { key: "envio_base", label: "Tarifa base de envío" },
      { key: "envio_adicional", label: "Kilómetro adicional" },
      { key: "express_entre_semana", label: "Express entre semana" },
      { key: "express_fin_de_semana", label: "Express fin de semana" },
    ];

    function formatMoney(value) {
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      }).format(Number(value || 0));
    }

    onMounted(async () => {
      const loader = loading.show();
      try {
        const response = await axios.get("/api/pricings", {
          params: { pricing_id: route.params.pricing_id },
        });
        pricing.value = response.data;
      } catch (error) {
        useToast().error(
          error.response?.data?.error || "No se pudo cargar el esquema de precios",
          { position: "top-right" }
        );
      } finally {
        loaded.value = true;
        loader.hide();
      }
    });

    return { router, pricing, loaded, moneyFields, formatMoney };
  },
};
</script>
